import * as React from 'react'
import { SVGProps, memo } from 'react'

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={17}
    height={18}
    viewBox='0 0 17 18'
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M12.633 1.128c-.19.591-.623 1.385-.954 1.753-.317.352-1.245.895-1.882 1.099-.358.115-.452.336-.182.43.088.03.486.207.886.392 1.098.51 1.569 1.07 2.175 2.588.077.192.186.334.243.316.056-.02.23-.35.387-.736.52-1.279 1.151-1.902 2.4-2.366.286-.107.56-.23.608-.271.128-.113-.11-.295-.633-.485-1.164-.421-1.852-1.085-2.34-2.259-.358-.862-.54-.98-.708-.46Zm-6.03 2.384c-.03.048-.197.465-.373.927-1.066 2.806-2.26 4.07-4.794 5.08-.562.223-1.114.444-1.226.49a.342.342 0 0 0 0 .63c.112.046.668.268 1.235.494 1.417.564 1.933.89 2.836 1.79.662.662.847.917 1.25 1.734.262.526.607 1.306.769 1.733.273.72.312.775.55.775.24 0 .276-.054.6-.912.698-1.854 1.381-2.943 2.35-3.744.691-.573 1.836-1.189 2.882-1.552 1.323-.46 1.387-.786.228-1.173-.863-.288-2.478-1.118-3.021-1.553-.985-.788-1.742-1.975-2.435-3.824-.301-.802-.377-.929-.572-.953-.124-.015-.25.01-.279.058Z'
      clipRule='evenodd'
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
